import { render, staticRenderFns } from "./media_planning_commission_dialog.vue?vue&type=template&id=855e2d6e&scoped=true"
import script from "./media_planning_commission_dialog.vue?vue&type=script&lang=js"
export * from "./media_planning_commission_dialog.vue?vue&type=script&lang=js"
import style0 from "./media_planning_commission_dialog.vue?vue&type=style&index=0&id=855e2d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e2d6e",
  null
  
)

export default component.exports